import React, {Component} from 'react';
import classNames from 'classnames';
import Radium from 'radium';
import PropTypes from 'prop-types';
import CreditCard from "./CreditCard";

import Checkbox from 'components/checkbox';
import RadioButton from "../../../../components/radio-button";
import {t} from "../../../../components/Translate";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../components-new/buttons/BlueButton";

const styles = {
  radioRightDiv: {
    paddingLeft: '50px',
  },
  radioLeftDiv: {
    float: 'left',
    padding: '3px'
  },
  modalContent: {
    background: '#FFFFFF',
  },
  cardDiv: {
    padding: '1px 40px',
    cursor: 'pointer',
  },
  rememberCard: {
    color: '#A4ADC1',
    fontSize: '14px'
  },
  status: {
    padding: '40px 0px 0px 40px',
    fontWeight: 'bold',
    color: '#3D568F',
    fontSize: '20px',
  },
  tariff: {
    padding: '40px 40px 0px 40px',
  },
  fee: {
    padding: '32px 40px 0px 40px',
  },
  content: {
    button: {
      padding: '30px 40px 0px 40px',
      textAlign: 'center',
      marginBottom: '20px'
    },
    status: {
      padding: '40px 0px 0px 40px',
      fontWeight: 'bold',
      color: 'rgb(33, 52, 97)',
      fontSize: '20px',
    },
    tariff: {
      padding: '40px 40px 0px 40px',
    },
    fee: {
      padding: '32px 40px 0px 40px',
    },
  },
};

const renderTariffProperty = (name, value, country) => {
  const currency = country === 'am' ? '֏' : '$';
  return (
    <div style={styles.fee}>
      <span style={{fontSize: '14px', color: '#A4ADC1'}}>
        {name}
      </span>
      <span style={{float: 'right', fontSize: '16px'}}>
        <span style={{color: '#F04D4D'}}>
          {value} {currency}
        </span>
      </span>
    </div>
  )
};

class TariffChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRememberSelected: false,
      cardHolderId: -1
    };
  }

  handleSelectAllClick = () => {
    const {isRememberSelected} = this.state;
    this.setState({
      isRememberSelected: !isRememberSelected
    });
  };
  handleRadioButtonChange = (cardHolderId) => {
    this.setState({
      cardHolderId
    });
  };

  render() {
    const {tariff, onHandlePay, onHandleCancel, country, tabId, cards, btnState, isActiveTariff, user} = this.props;
    const {isRememberSelected, cardHolderId} = this.state;
    return (<div style={styles.modalContent}>
      <div style={styles.content.status}>
      <span>
        {t({text: "package", user})}
        {' '}
        {t({text: tariff.status, user})}
      </span>
      </div>
      <div style={[styles.tariff, {fontSize: '18px'}]}>
      <span style={{fontWeight: 'bold'}}>
        {tariff.tariffPackage === undefined ? '' : tariff.tariffPackage.name + ' '}
      </span>
        (+
        {' '}
        {tariff.additionalOperators}
        {' '}
        {t({text: "billingOperator", user})} / +
        {' '}
        {tariff.additionalClients}
        {' '}
        {t({text: "billingBot", user})})
      </div>
      {renderTariffProperty(`${t({text: "fee", user})}:`, tariff.fee, country)}
      {tabId !== 2 && renderTariffProperty(`${t({text: "currentDeposit", user})}:`, tariff.currentDeposit, country)}
      {tabId !== 2 && renderTariffProperty(`${t({text: "currentUnusedFee", user})}:`, tariff.leftFromPrevTariff, country)}
      {tabId !== 2 && renderTariffProperty(`${t({text: "finalDeposit", user})}:`, tariff.creditBalance, country)}
      {tabId !== 2 && renderTariffProperty(`${t({text: "finalAmount", user})}:`, tariff.finalAmount, country)}

      <div style={{paddingTop: '20px'}}>
        {tariff.finalAmount > 0 && isActiveTariff &&
        <div>
          {
            cards && cards.map((card, index) => (
              <div key={index} style={styles.cardDiv} onClick={() => this.handleRadioButtonChange(card.cardHolderId)}>
                <div style={[styles.radioLeftDiv, {paddingTop: '23px'}]}>
                  <RadioButton selected={cardHolderId === card.cardHolderId}/>
                </div>
                <div style={styles.radioRightDiv}>
                  <CreditCard key={card.cardHolderId} cardNumber={card.cardNumber} clientName={card.clientName}/>
                </div>
              </div>
            ))
          }
          {/*todo open card*/}
          <div style={[styles.cardDiv, {padding: '15px 40px'}]} onClick={() => this.handleRadioButtonChange(-1)}>
            <div style={styles.radioLeftDiv}>
              <RadioButton selected={cardHolderId === -1}/>
            </div>

            <div style={styles.radioRightDiv}>
              <p style={{fontSize: '16px'}}>{t({text: "addNewCard", user})}</p>
              <div style={{display: 'flex', padding: '1px', alignItems: 'center'}}>
                <Checkbox
                  checked={isRememberSelected}
                  handleChange={this.handleSelectAllClick}
                  size="15px"
                  wrapperStyle={{height: '15px'}}/>
                <p style={styles.rememberCard}>{t({text: "rememberTheCardAfterFilling", user})}</p>
              </div>
            </div>
          </div>
        </div>
        }
      </div>

      <div style={styles.content.button}>
        <SilverButton styles={{marginRight: '20px'}} width={'125px'} type={'button'} onClick={onHandleCancel} children={t({text: "cancel", user})}/>
        {
          btnState === true ? (
              <BlueButton width={'140px'} type={'button'} onClick={() => onHandlePay(isRememberSelected, cardHolderId)} children={t({text: "confirm", user})}/>
          ) : (
              <BlueButton disabled={true} width={'140px'} type={'button'} onClick={() => onHandlePay(isRememberSelected, cardHolderId)} children={t({text: "confirm", user})}/>
          )
        }
      </div>
    </div>);
  }
}

TariffChange.propTypes = {
  tariff: PropTypes.object.isRequired,
  btnState: PropTypes.bool.isRequired,
  isActiveTariff: PropTypes.bool.isRequired,
  cards: PropTypes.array.isRequired,
  country: PropTypes.string.isRequired,
  tabId: PropTypes.number.isRequired,
  onHandlePay: PropTypes.func.isRequired,
  onHandleCancel: PropTypes.func.isRequired,
};

TariffChange.defaultProps = {
  cards: [],
};

export default Radium(TariffChange);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/billing/TariffChange.jsx